var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('limitless-page-header'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('limitless-card-tabs-view',{attrs:{"links":_vm.routes}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }